
import NoData from '@/components/NoData';
import styles from './index.less';
import { List, PullRefresh } from 'react-vant';
import { history, useModel } from '@umijs/max';
import { useEffect, useRef, useState } from 'react';
import { getWechatQuestionnaire } from '@/service/banner';
import { EyeO } from '@react-vant/icons';
import dayjs from 'dayjs';
// import sUrl1 from '@/assets/home/s2.png';

const SurverList = (props: any) => {
  const { type } = props;

  // useEffect(() => {
  //   onRefresh()
  // }, [type])
  
  const formatStatus = (item: any) => {
    if (item.response === '1') {
      return '已提交';
    } else if (item.endFlag === '1' ) {
      return '已结束';
    } else {
      const startTime = dayjs(item.startTime);
      const endTime = dayjs(item.endTime);
      const currentTime = dayjs();
      const isAfterCurrentTime = currentTime.isAfter(endTime);
      const isBeforeCurrentTime = currentTime.isBefore(startTime);
      if (isBeforeCurrentTime) {
        return '未开始';
      }

      if (isAfterCurrentTime) {
        return '已结束';
      }

      if (!isAfterCurrentTime && !isBeforeCurrentTime) {
        return '进行中';
      }
    }
  };
  const [WechatQuestionnaire, setWechatQuestionnaire] = useState([]);
  const pageNum  = useRef(1);
  const {defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );

  const click = (item: any) => {
    console.log(item);
    history.push(`/questionnaireDetail?sequenceNbr=${item.sequenceNbr}`);
  };
 
  const [finished, setFinished] = useState<boolean>(false)

  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setWechatQuestionnaire([])
    /**
     * type: 1 全部 2 进行中 3 已提交
     * endStatus = 0 进行中；
     * endStatus = 1已结束；
     * endStatus = 2已提交；
     * endStatus = 其他值 全部； 
     * 
     */
    const endStatus = type === 2 ? 0 : type === 3 ? 2 : undefined;
    const data = await getWechatQuestionnaire({ pageNum: pageNum.current, pageSize: 10, endStatus, type: 1, communityId: defaultRoom?.communityId, floorId: defaultRoom?.floorId })
    const listData: any =  [...WechatQuestionnaire, ...data.rows]
    if (isRefresh || pageNum.current === 1) {
      setWechatQuestionnaire(data.rows); 
    } else {
      setWechatQuestionnaire(listData);
    }
 
    if (data.rows.length === data.total || data.rows.length < 10 || !data.rows.length || data.total === 0) { // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1
      setFinished(false); // 仍有数据可加载，保持为false
    }
  }

  const onRefresh = async () => {
    pageNum.current = 1
    setFinished(true)
    setWechatQuestionnaire([])
    onLoadRefresh(true)
  }

  const formatStyle = (item: any) => {
    if (formatStatus(item)) {
      let data = formatStatus(item);
      switch(data) {
        case '进行中':
          return styles.statusIng
          break;
        case '已结束':
          return styles.statusEnd
          break;
        case '已提交':
          return styles.statusSubmit
          break;
        case '未开始':
          return styles.statusUnStart
          break;
        default:
          return styles.status
          break;
      }
    } else {
      return styles.status
    }
  }
 
  return ( 
    <div className= {styles.surverList}>
      <PullRefresh onRefresh={onRefresh} >
        <List finished={finished} onLoad={onLoadRefresh} finishedText={!WechatQuestionnaire?.length ? '' : '没有更多了'}>
          {WechatQuestionnaire?.length !== 0 ? (
            <>
              {WechatQuestionnaire.map((item: any) => (
                <div
                  onClick={() => click(item)}
                  className={styles['contentBox']}
                  key={item.sequenceNbr}
                >
                     <div className={formatStyle(item)}>{formatStatus(item)}</div>
                      {/* <div className={styles.imgBox}><img src={sUrl1} alt=""  /></div> */}
                      <div className={styles.rightBox}>
                        <div className={styles.title}>
                          <section>{item.title}</section>
                          {/* <Arrow /> */}
                        </div>
                        
                        <div className={styles.box}>
                          <div className={styles['viewBox']}>
                            <div>{item.publishTime ? item.publishTime : '-'}</div>
                            <div className={styles.boxs}>
                              <EyeO className={styles.icon} />
                              {item.viewCount ? item.viewCount : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
              ))}
            </>
          ) : (
            <NoData />
          )}
        </List>
      </PullRefresh>
    </div>
  )
}

export default SurverList